export const checkPrevValue = (data, prevData, conditionField) => {
    let result = false
    if (data[conditionField] !== prevData[conditionField] || Object.keys(prevData) === 0) result = true

    return result
} 

